import { FormsContainer } from './FormsContainer';

const name = 'FormsContainer';

export { FormsContainer, name };
